import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FacturaVentaEfectivoDtoOut, VentaEfectivoDtoIn, VentaEfectivoDtoOut } from '../models/venta-efectivo.model';
import { VentaDtoIn, VentaDtoOut } from '../models/venta.model';

@Injectable({
  providedIn: 'root',
})
export class ContabilidadVentasService {
  private readonly apiUrl = environment.apiUrl;
  private readonly endpoint = `${this.apiUrl}/contabilidad-onda/ventas`;

  constructor(private readonly http: HttpClient) {}

  obtenerVentas(): Observable<VentaDtoOut[]> {
    return this.http.get<VentaDtoOut[]>(this.endpoint).pipe(catchError(this.handleError('obtenerVentas')));
  }

  obtenerVentaPorId(id: number): Observable<VentaDtoOut> {
    return this.http.get<VentaDtoOut>(`${this.endpoint}/${id}`).pipe(catchError(this.handleError('obtenerVentaPorId')));
  }

  crearVentaDomiciliacionBancaria(sepaId: number): Observable<VentaDtoOut> {
    return this.http
      .post<VentaDtoOut>(`${this.endpoint}/crear-venta-domiciliacion`, { sepaId: sepaId })
      .pipe(catchError(this.handleError('crearVenta')));
  }

  crearVentaEfectivo(venta: VentaEfectivoDtoIn): Observable<VentaEfectivoDtoOut> {
    return this.http
      .post<VentaEfectivoDtoOut>(`${this.endpoint}/crear-venta-efectivo`, venta)
      .pipe(catchError(this.handleError('crearVentaEfectivo')));
  }

  actualizarVenta(venta: VentaDtoIn): Observable<VentaDtoOut> {
    return this.http
      .put<VentaDtoOut>(`${this.endpoint}/${venta.id}`, venta)
      .pipe(catchError(this.handleError('actualizarVenta')));
  }

  eliminarVenta(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`).pipe(catchError(this.handleError('eliminarVenta')));
  }

  exportarVentaExcel(id: number): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/${id}/exportar-excel`, { responseType: 'blob' })
      .pipe(catchError(this.handleError('exportarVentaExcel')));
  }

  exportarVentaCsv(id: number): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/${id}/exportar-csv`, { responseType: 'blob' })
      .pipe(catchError(this.handleError('exportarVentaCsv')));
  }

  validarVenta(id: number): Observable<void> {
    return this.http
      .put<void>(`${this.endpoint}/${id}/validar-venta`, {})
      .pipe(catchError(this.handleError('validarVenta')));
  }

  getFacturasParaVentaEnEfectivo(empresaFacturadoraId: number): Observable<FacturaVentaEfectivoDtoOut[]> {
    return this.http.get<FacturaVentaEfectivoDtoOut[]>(
      `${this.endpoint}/facturas-venta-efectivo/${empresaFacturadoraId}`
    );
  }

  cambiarCodigoAlbaran(ventaId: number, nuevoCodigoAlbaran: number): Observable<void> {
    return this.http
      .put<void>(`${this.endpoint}/${ventaId}/cambiar-codigo-albaran`, { nuevoCodigoAlbaran: nuevoCodigoAlbaran })
      .pipe(catchError(this.handleError('cambiarCodigoAlbaran')));
  }

  private handleError(operation: string) {
    return (error: any) => {
      console.error(`ContabilidadVentasService - Error en operación [${operation}]:`, error);
      throw error;
    };
  }
}
